import { useLayoutEffect, useState } from 'react';

import { observer } from 'mobx-react';

import { useStores } from '../../stores/useStores';
import { checkAppearanceLimitLeft } from '../../utils/liveBannerAppearanceTracker';

import { LiveBannerDisplay } from './LiveBannerDisplay';

const LiveBanner = observer(() => {
  const { uiStore, userStore } = useStores();
  const { bannerMessage, showCloseButton, showLogo, bannerKey, appearanceLimit } = uiStore.liveBannerData;
  const userId = userStore.profile?.firebaseUid;

  const [appearanceAllowed, setAppearanceAllowed] = useState<boolean>(false);

  useLayoutEffect(() => {
    if (!bannerMessage) {
      setAppearanceAllowed(false);
      return;
    }
    if (appearanceLimit > 0 && bannerKey) {
      const isAppearanceLimit = checkAppearanceLimitLeft(userId, bannerKey, appearanceLimit);
      setAppearanceAllowed(isAppearanceLimit);
    } else {
      setAppearanceAllowed(true);
    }
  }, [bannerMessage, appearanceLimit, bannerKey, userId]);

  const showBanner = bannerMessage != null && bannerMessage !== '' && appearanceAllowed;

  if (!showBanner) {
    return null;
  }

  return (
    <LiveBannerDisplay
      bannerMessage={bannerMessage}
      showLogo={showLogo}
      onCloseClick={showCloseButton ? () => uiStore.resetLiveBannerData() : undefined}
    />
  );
});

export default LiveBanner;
